import {
  Component,
  OnInit,
  Compiler,
  ViewChild,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as moment from 'moment';
import { ConstantValue } from '../util/constant.config';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';

@Component({
  templateUrl: 'addResource.component.html',
  styleUrls: ['addResource.component.css'],
})
export class AddResourceComponent implements OnInit {
  @ViewChild('closeModel', { read: ElementRef }) closeModel: ElementRef;
  statusDiv: FormControl = new FormControl();
  users: any = {};
  apprArry: any[] = [];
  status = '';
  isDisabled: boolean = false;
  isAppr: any;
  addUserForm: any;
  config: any;
  loading: boolean = false;
  fetchData: any[] = [];
  submitted = false;
  userId: any = 0;
  loginImageURL: any = '';
  baseURL: any = null;
  loginUserName: any = '';
  showHideModel: boolean = true;
  skillData: any[] = [];
  userUpdatedId: Number = 0;
  empCode: any;
  resourceName: any;
  resourceEmail: any;
  typesResource: any = 'Regular';
  joinDate: any;
  leaveDate: any;
  selectedEmail: any = '';
  selectedSVEmail: any = '';
  selectedUserId: any = '';
  resourceManager: any;
  resourceManagerEmail: any;
  currentRole: any = JSON.parse(localStorage.user).userData.userRoll;
  inactiveUserCount = 0;
  activeUserCount = 0;
  skillRatingData: any[] = [];
  towerId: any;
  positionList: any = [];
  currentPositionList: any = [];
  nextPositionList: any = [];
  userRoll: number = 0;
  userType: any = '';
  allPositions: any = [];
  userRole: any = JSON.parse(localStorage.user).userData.userRoll;
  resetUserId: any = '';
  resetUserData: any = [];
  nominatedUseristory: any = [];
  dtOptions: DataTables.Settings = {};
  userNotesForm: FormGroup;
  userNotesList: any = [];
  userAllNotesList: any = [];
  empStatusList = ConstantValue.EmpStatusList;
  batchNoList = ConstantValue.BatchNoList;
  journeyCompletionDate: any;
  trStatusList = ConstantValue.TrStatusList;
  curStatus = 2;
  columnList = [];
  dropdownSettings: IDropdownSettings = {};
  selectedItems = [];
  dtRendered: any = true;
  dtTrigger: Subject<any> = new Subject();
  dtElement: DataTableDirective;
  importUserForm: FormGroup;
  ibuList: any = [];
  ibu: any = '';
  functionList: any = [];
  function: any = '';
  selectedIbuId: any = null;
  towerList: any = [];
  alltowerList: any = [];
  selectedTowerId: any;
  tower: any = '';
  isNextTowerSame: boolean = true;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private excelService: ExcelService,
    private commonService: CommonService,
    private common: Common,
    private render: Renderer2,
    private cdr: ChangeDetectorRef,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout();
      return;
    }
    if (this.users && this.users.userData) {
      if (this.users.userData.userFullName) {
        this.loginUserName = this.users.userData.userFullName;
      } else {
        this.loginUserName = this.users.userData.userName;
      }
      this.userRoll = this.users.userData.userRoll;
      this.users.userFullName = this.users.userData.userFullName.toLowerCase();
      this.towerId = this.users.userData.towerId;
    }

    let currentDate = new Date();
    this.config = config;
    this.config.minDate = {
      year: currentDate.getFullYear() - 40,
      month: currentDate.getMonth(),
      day: currentDate.getDate(),
    };
    this.config.maxDate = { year: 2099, month: 12, day: 31 };
    this.config.markDisabled = false;
    this.loginImageURL = this.appConfig.getDefaultImgURL();
    this.initUserNotesForm();
    this.columnList = ConstantValue.AddResourceAllColumnList;
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.render.removeClass(document.body, 'modal-open');
        $(document.body).removeClass('modal-open');
        $('.modal-backdrop').remove();
      });
    this.fetchuserData();
    this.fetchSkillRatingData();
    this.fetchSkillsData();
    this.fetchPositions();
    this.getAllUserNotes();

    this.disabledFnc();
    this.initImportUserForm();
    this.getAllIBUInfo();
    this.dropdownSettings = {
      singleSelection: false,
      // idField: 'item_id',
      idField: 'slug',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.selectedItems = ConstantValue.AddResourceColumns;
  }

  initImportUserForm() {
    this.importUserForm = this.formBuilder.group({
      userFile: ['', Validators.required],
      towerId: [],
    });
  }

  /**
   * Initalize the user Notes form.
   */
  initUserNotesForm() {
    this.userNotesForm = this.formBuilder.group({
      userId: ['', Validators.required],
      notesId: [''],
      userNotes: ['', Validators.required],
    });
  }
  /**
   * Submit User Notes Form
   * @param formInfo
   * @returns
   */
  onSubmitUserNotes(formInfo) {
    if (!formInfo.userNotes) {
      localStorage.setItem('errorMsg', 'Please enter user Notes!');
      this.commonService.showerror();
      return;
    }
    var userId = JSON.parse(localStorage.getItem('user')).userData.userId;
    var userName = JSON.parse(localStorage.getItem('user')).userData
      .userFullName;
    formInfo.noteUserId = userId;
    formInfo.noteUserName = userName;
    this.commonService.addUserNotes(formInfo).subscribe(
      (data) => {
        this.loading = false;
        localStorage.setItem('errorMsg', 'Note Added successfully!');
        document.getElementById('addNotesPopContainer').click();
        this.commonService.showerror();
        this.getUserNotes(formInfo.userId);
        this.userNotesForm.patchValue({
          userNotes: '',
        });
      },
      (error) => {
        this.loading = false;
        localStorage.setItem('errorMsg', 'Must enter all the fields!');

        document.getElementById('addNotesPopContainer').click();
        this.commonService.showerror();
      }
    );
  }
  /**
   *
   */
  onEditUserNotes(userInfo) {
    this.userNotesForm.get('userId').setValue(userInfo?.userId);
    this.getUserNotes(userInfo?.userId);
  }
  /**
   * Get user Notes
   */
  getUserNotes(userId) {
    this.commonService.getUserNotes(userId).subscribe(
      (data) => {
        this.loading = false;
        if (data) {
          this.userNotesList = data;
        }
      },
      (error) => {
        this.loading = false;
      }
    );
  }
  /**
   * Edit Notes
   */
  editNotes(notes) {
    this.userNotesForm.get('userNotes').setValue(notes?.userNotes);
  }
  /**
   * Add new notes
   */
  addNewNotes() {
    this.userNotesForm.get('userNotes').setValue('');
    this.userNotesForm.get('notesId').setValue('');
  }
  /**
   * Get user Notes
   */
  getAllUserNotes() {
    this.commonService.getAllUserNotes().subscribe(
      (data) => {
        this.loading = false;
        if (data) {
          this.userAllNotesList = data;
        }
      },
      (error) => {
        console.log('Error', error);
        this.loading = false;
      }
    );
  }
  /**
   * Return Users notes
   */
  returnUserNotes(userId) {
    for (let i = 0; i < this.userAllNotesList.length; i++) {
      if (userId == this.userAllNotesList[i].userId) {
        return this.userAllNotesList[i].userNotes;
      }
    }
  }

  // /fetch user information data
  private fetchSkillRatingData() {
    this.skillRatingData = [];
    this.commonService
      .fetchSkillRatingData()
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            this.skillRatingData = data;
          } else {
            localStorage.setItem('errorMsg', 'Data Not Found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private initalizeUserForm() {
    this.userUpdatedId = 0;
    let groupForm = {
      empCode: ['', Validators.required],
      resourceName: ['', Validators.required],
      resourceEmail: ['', Validators.required],
      resourceManager: ['', Validators.required],
      resourceManagerEmail: ['', Validators.required],
      SUPCode: ['', Validators.required],
      SLSUPCode: ['', Validators.required],
      SLS: ['', Validators.required],
      SLSE: ['', Validators.required],
      // SLST: ['', Validators.required],
      TTA: ['', Validators.required],

      typesResource: new FormControl('Contractor'),
      currentPosition: ['', Validators.required],
      nextPosition: ['', Validators.required],
      joinDate: ['', Validators.required],
      leaveDate: new FormControl(null),
      empStatus: ['', Validators.required],
      batchNo: [''],
      journeyCompletionDate: new FormControl(null),
      isApproved: [''],
    };
    this.addUserForm = this.formBuilder.group(groupForm);
    this.addUserForm.patchValue({
      empStatus: 1,
      isApproved: 2,
    });
  }

  // edit user information
  private onEditSubmit(fetchuserData) {
    this.isNextTowerSame = true;
    if (fetchuserData) {
      this.userUpdatedId = fetchuserData.userId;
      let groupForm = {
        empCode: new FormControl(fetchuserData.empCode),
        resourceName: new FormControl(fetchuserData.userName),
        resourceEmail: new FormControl(fetchuserData.email),
        resourceManager: new FormControl(fetchuserData.resourceManager),
        resourceManagerEmail: new FormControl(
          fetchuserData.resourceManagerEmail
        ),
        SUPCode: new FormControl(fetchuserData.SUPCode),
        SLSUPCode: new FormControl(fetchuserData.SLSUPCode),
        SLS: new FormControl(fetchuserData.SLS),
        SLSE: new FormControl(fetchuserData.SLSE),
        // SLST: new FormControl(fetchuserData.SLST),
        TTA: new FormControl(fetchuserData.TTA),

        typesResource: new FormControl(fetchuserData.typeResource),
        currentPosition: new FormControl(fetchuserData.currentPosition),
        nextPosition: new FormControl(fetchuserData.nextPosition),
        joinDate: new FormControl(
          this.common.getJSONObj(fetchuserData.joinDate)
        ),
        leaveDate: new FormControl(
          this.common.getJSONObj(fetchuserData.leaveDate)
        ),
        empStatus: new FormControl(fetchuserData.empStatus),
        batchNo: new FormControl(
          fetchuserData.batchNo ? fetchuserData.batchNo : ''
        ),
        journeyCompletionDate: new FormControl(
          this.common.getJSONObj(fetchuserData.journeyCompletionDate)
        ),
        isApproved: new FormControl(fetchuserData.isApproved),
      };

      this.setFieldsData(fetchuserData);
      this.curStatus = fetchuserData.isApproved;
      this.addUserForm = this.formBuilder.group(groupForm);
    }
  }

  private showPrompt() {
    var that = this;
    setTimeout(function () {
      localStorage.setItem(
        'errorMsg',
        'Please correctly fill all the required fields'
      );
      that.commonService.showerror();
      localStorage.removeItem('errorMsg');
    }, 2000);
  }

  //close dailog box
  private closeModels() {
    this.closeModel.nativeElement.click();
  }

  private onEmailClickData(selectedEmail, selectedSVEmail, selectedUserId) {
    this.selectedEmail = selectedEmail;
    this.selectedSVEmail = selectedSVEmail;
    this.selectedUserId = selectedUserId;
  }

  private onEmailClick() {
    var email = this.selectedEmail;
    var svEmail = this.selectedSVEmail;
    this.commonService
      .sendEmailNiit(
        'sendRatingInvi',
        email,
        svEmail,
        'true',
        'true',
        this.selectedUserId,
        this.towerId
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          localStorage.setItem('errorMsg', 'Email sent!');
          this.commonService.showerror();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private onAllEmailClick() {
    var email = this.selectedEmail;
    var svEmail = this.selectedSVEmail;
    this.commonService
      .sendEmailToAll('sendRatingInviToAll')
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          localStorage.setItem(
            'errorMsg',
            'Email has been sent to all these resources!'
          );
          this.commonService.showerror();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // /fetch user information data
  private fetchuserData() {
    this.loading = true;
    var userEmail = '';
    if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
      userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;
    this.commonService
      .getUsersListByPost(
        JSON.parse(localStorage.getItem('user')).userData.towerId,
        userEmail
      )
      .pipe(first())
      .subscribe(
        (data) => {
          let userIds = [];
          if (data) {
            for (let i = 0; i < data.length; i++) {
              if (data[i].userId) {
                userIds.push(data[i].userId);
              }
              this.isAppr = data[i].isApproved;
              this.apprArry.push(this.isAppr);
            }
          }
          if (userIds.length > 0) {
            this.fetchUserSkillsData(userIds, data);
            this.getAllNextPositions(
              userIds,
              JSON.parse(localStorage.user).userData.towerId
            );
          } else {
            this.loading = false;
            localStorage.setItem('errorMsg', 'Users Not Found');
            this.commonService.showerror();
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // /fetch user information data
  private fetchPositions() {
    // var towerId = JSON.parse(localStorage.user).userData.towerId;
    let towerId = null;
    this.commonService
      .getAllPositionInfo(towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.positionList = data;
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  // /fetch user information data
  private fetchNextPositions(towerId, positionId = '') {
    this.commonService.getAllPositionInfo(towerId).subscribe(
      (data) => {
        this.nextPositionList = data;
        const formTower: any = document.querySelector('#form-next-role');
        if (formTower) {
          setTimeout(() => {
            formTower.value = positionId;
          }, 200);
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  // /fetch user information data
  private fetchCurrentPositions(towerId, positionId = '') {
    this.commonService.getAllPositionInfo(towerId).subscribe(
      (data) => {
        this.currentPositionList = data;
        const formTower: any = document.querySelector('#form-current-role');
        if (formTower) {
          setTimeout(() => {
            formTower.value = positionId;
          }, 200);
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private getPositionName(positionId) {
    for (let i = 0; i < this.positionList.length; i++) {
      if (this.positionList[i].positionId == positionId)
        return this.positionList[i].positionName;
    }
  }

  //fetch user skills data
  private fetchUserSkillsData(userIds: any[], userData) {
    this.commonService
      .fetchAllFunSkills(userIds)
      .pipe(first())
      .subscribe(
        (data) => {
          for (let j = 0; j < userData.length; j++) {
            let userSkill = [];
            for (let i = 0; i < data.length; i++) {
              if (userData[j].userId == data[i].userId) {
                let skillLevel = data[i].skillLevel;
                let skillName = '';
                this.skillData.forEach((litem, index) => {
                  if (litem.skillId == data[i].skillId) {
                    skillName = litem.skillName;
                  }
                });
                userSkill.push({
                  skillId: data[i].skillId,
                  skillLevel: skillLevel,
                  skillName: skillName,
                });
              }
            }
            userData[j]['userSkill'] = userSkill;
          }
          this.fetchData = userData;
          this.dtRendered = false;
          this.cdr.detectChanges();
          this.dtRendered = true;
          this.cdr.detectChanges();
          this.categoriseLeaveUsers();
          this.countActiveAndInactiveUsers();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //fetch user skills data
  private getAllNextPositions(userIds, towerId) {
    this.commonService
      .getAllNextPositions(userIds, towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.allPositions = data;
          var that = this;
          setTimeout(function () {
            that.loading = false;
          }, 1000);
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //categorise leave users
  private categoriseLeaveUsers() {
    for (let i = 0; i < this.fetchData.length; i++) {
      if (this.fetchData[i].leaveDate) {
        let currentDate = new Date();
        let userLeaveDate = new Date(this.fetchData[i].leaveDate);
        if (currentDate > userLeaveDate) {
          this.fetchData[i]['leaveStyle'] = 'red';
        }
      }
    }
  }

  // validate resoucre leaving date should be equal or lessthen from current date
  private countActiveAndInactiveUsers() {
    this.inactiveUserCount = 0;
    this.activeUserCount = 0;
    for (let i = 0; i < this.fetchData.length; i++) {
      let isFound = false;
      //remove user from the list if having leave date less then current date
      let currentTime = this.common.getTime(new Date());
      if (this.fetchData[i].leaveDate) {
        let leavingTime = this.common.getTime(this.fetchData[i].leaveDate);
        if (currentTime > leavingTime) {
          isFound = true;
        }
      }
      if (isFound) {
        this.inactiveUserCount++;
        this.fetchData[i]['leaveUserCSS'] = 'leaveUserCSS';
      } else {
        this.fetchData[i]['leaveUserCSS'] = '';
        this.activeUserCount++;
      }
    }
  }

  // suave user information
  private onSubmit(userFormDetails) {
    if (this.addUserForm.invalid) {
      this.submitted = true;
      return;
    } else {
      if (!this.validateEmail(userFormDetails.resourceEmail)) {
        localStorage.setItem('errorMsg', 'Invaild Email id!');
        this.commonService.showerror();
        return;
      }
      if (!this.validateEmail(userFormDetails.resourceManagerEmail)) {
        localStorage.setItem('errorMsg', 'Invaild resource manager email!');
        this.commonService.showerror();
        return;
      }
      if (!this.validateEmail(userFormDetails.SLSE)) {
        localStorage.setItem(
          'errorMsg',
          'Invaild Second Level Supervisor Email!'
        );
        this.commonService.showerror();
        return;
      }
      if (
        Number(userFormDetails.currentPosition) ==
        Number(userFormDetails.nextPosition)
      ) {
        localStorage.setItem(
          'errorMsg',
          'Current role and Next role should not be same!'
        );
        this.commonService.showerror();
        return;
      }
      let userSkillData = this.setUserSkillData(userFormDetails, '');
      userFormDetails['createdByEmail'] = this.users.userData.emailAddress;
      let userInfo = this.isResourceExit(userFormDetails.resourceEmail);
      if (userInfo) {
        localStorage.setItem('errorMsg', userInfo);
        this.commonService.showerror();
        return;
      }
      userFormDetails['towerId'] = this.towerId;
      userFormDetails['userRoll'] = this.userRole;
      this.commonService
        .saveUserData(userFormDetails)
        .pipe(first())
        .subscribe(
          (data) => {
            this.addUserForm.reset();
            localStorage.setItem(
              'errorMsg',
              'User successfully added in TR Nominees'
            );
            localStorage.setItem('isReload', 'true');
            this.closeModels();
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
            this.fetchuserData();
          },
          (error) => {
            localStorage.setItem('errorMsg', 'Must Enter all the fields');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        );
    }
  }
  /**
   * On change role check both are same or not.
   * @param resourceEmail
   */
  roleCheck() {
    const userFormDetails = this.addUserForm.value;
    if (
      Number(userFormDetails.currentPosition) ==
      Number(userFormDetails.nextPosition)
    ) {
      this.addUserForm.controls['currentPosition'].setValue('');
      this.addUserForm.controls['nextPosition'].setValue('');
      localStorage.setItem(
        'errorMsg',
        'Current role and Next role should not be same!'
      );
      this.commonService.showerror();
      return;
    }
  }
  //check user is exits
  private isResourceExit(resourceEmail) {
    let userInfo = null;
    for (let i = 0; i < this.fetchData.length; i++) {
      if (resourceEmail == this.fetchData[i].email) {
        userInfo =
          'TR Nominee: ' + this.fetchData[i].userName + ' is already exits!';
        break;
      }
    }
    return userInfo;
  }

  //update user infromation
  private onUpdateSubmit(userFormDetails) {
    if (this.addUserForm.invalid) {
      return;
    }
    if (!this.validateEmail(userFormDetails.resourceEmail)) {
      localStorage.setItem('errorMsg', 'Invaild Email id!');
      this.closeModels();
      this.commonService.showerror();
      return;
    }
    if (!this.validateEmail(userFormDetails.resourceManagerEmail)) {
      localStorage.setItem('errorMsg', 'Invaild resource manager email!');
      this.closeModels();
      this.commonService.showerror();
      return;
    }
    if (!this.validateEmail(userFormDetails.SLSE)) {
      localStorage.setItem(
        'errorMsg',
        'Invaild Second Level Supervisor Email!'
      );
      this.closeModels();
      this.commonService.showerror();
      return;
    }
    if (
      Number(userFormDetails.currentPosition) ==
      Number(userFormDetails.nextPosition)
    ) {
      localStorage.setItem(
        'errorMsg',
        'Current role and Next role should not be same!'
      );
      this.closeModels();
      this.commonService.showerror();
      return;
    }
    if (userFormDetails != null && this.userUpdatedId > 0) {
      userFormDetails['userId'] = this.userUpdatedId;
      userFormDetails['joinDate'] = this.common.getDateYYMMDD(
        userFormDetails.joinDate
      );
      userFormDetails['leaveDate'] = this.common.getDateYYMMDD(
        userFormDetails.leaveDate
      );
      userFormDetails['updatedByEmail'] = this.users.userData.emailAddress;
      userFormDetails['updatedByName'] = this.users.userData.userFullName;
      userFormDetails['journeyCompletionDate'] = this.common.getDateYYMMDD(
        userFormDetails.journeyCompletionDate
      );
      userFormDetails['towerId'] = this.towerId;

      this.commonService
        .updateUserData(userFormDetails)
        .pipe(first())
        .subscribe(
          (data) => {
            localStorage.setItem('errorMsg', 'Data Successfully Updated');
            localStorage.setItem('isReload', 'true');
            this.closeModels();
            this.commonService.showerror();
            this.fetchuserData();
          },
          (error) => {
            localStorage.setItem('errorMsg', error.statusText);
            this.closeModels();
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        );
    }
  }

  //set user skill data
  private setUserSkillData(userFormDetails: any, userId: any) {
    let userSkillData = [];
    for (let i = 0; i < this.skillData.length; i++) {
      userSkillData.push({
        userId: userId,
        skillId: Number(this.skillData[i].skillId),
        skillLevel: userFormDetails[this.skillData[i].skillName],
      });
    }
    return userSkillData;
  }

  //delete user information
  private onDeleteSubmit(userInfo) {
    userInfo['deletedByEmail'] = this.users.userData.emailAddress;
    userInfo = this.setSkills(userInfo);
    this.commonService
      .userDeletion(userInfo)
      .pipe(first())
      .subscribe(
        (data) => {
          localStorage.setItem('errorMsg', 'Data Successfully Deleted');
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
          this.fetchuserData();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //set skills information
  private setSkills(userInfo) {
    let userSkills = userInfo.userSkill;
    for (let i = 0; i < userSkills.length; i++) {
      if (userSkills[i].skillName) {
        userInfo[userSkills[i].skillName] = userSkills[i].skillLevel;
      } else if (userSkills[i].skillName) {
        userInfo[userSkills[i].skillName] = userSkills[i].skillLevel;
      }
    }
    return userInfo;
  }

  //fetch skills data
  private fetchSkillsData() {
    this.commonService
      .fetchSkillData()
      .pipe(first())
      .subscribe(
        (data) => {
          this.skillData = data;
          this.initalizeUserForm();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //export resource history data
  excelReport() {
    let excelExportData = [];
    let headers = ['S.No.'];
    for (let selItem = 0; selItem < this.selectedItems.length; selItem++) {
      headers.push(this.selectedItems[selItem].item_text);
    }

    for (let i = 0; i < this.fetchData.length; i++) {
      let data = {};
      data[headers[0]] = i + 1;
      for (let column = 0; column < this.selectedItems.length; column++) {
        let slug = this.selectedItems[column].slug;
        if (slug == 'currentPosition' || slug == 'nextPosition') {
          data[headers[column + 1]] = this.getPositionName(
            this.fetchData[i][slug]
          );
        } else if (slug == 'empStatus') {
          data[headers[column + 1]] = this.getEmpStatus(
            this.fetchData[i][slug]
          );
        } else if (slug == 'isApproved') {
          data[headers[column + 1]] = this.commonService.getUserStatus(
            this.fetchData[i][slug]
          );
        } else if (slug == 'userId') {
          data[headers[column + 1]] = this.returnUserNotes(
            this.fetchData[i][slug]
          );
        } else if (slug == 'journeyCompletionDate') {
          data[headers[column + 1]] = this.fetchData[i][slug]
            ? moment(this.fetchData[i][slug]).format('YYYY-MM-DD')
            : ' ';
        } else {
          data[headers[column + 1]] = this.fetchData[i][slug];
        }
      }
      excelExportData.push(data);
    }
    this.excelService.generateExcel(headers, excelExportData, 'UserList');
  }

  private validateEmail(email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  private disabledFnc() {
    //console.log(this.statusDiv);
  }
  /**
   * Reset user for renominate if user completed nomitation process(nominationStatus = 2).
   */
  resetForReNominate() {
    const updateData = {
      userId: this.resetUserId,
      resetUserData: this.resetUserData,
    };
    this.commonService.resetUserforRenomination(updateData).subscribe(
      (data) => {
        if (data) {
          var userProfileHistory = {
            empCode: this.resetUserData.empCode,
            userName: this.resetUserData.userName,
            typeResource: this.resetUserData.typesResource,
            joinDate: this.resetUserData.joinDate,
            leaveDate: this.resetUserData.leaveDate,
            team: this.resetUserData.team,
            SUPCode: this.resetUserData.SUPCode,
            SLS: this.resetUserData.SLS,
            SLSE: this.resetUserData.SLSE,
            SLSUPCode: this.resetUserData.SLSUPCode,
            // 'SLST': userData.SLST,
            TTA: this.resetUserData.TTA,
            currentPosition: this.resetUserData.currentPosition,
            nextPosition: Number(this.resetUserData.nextPosition),
            email: this.resetUserData.email,
            resourceManager: this.resetUserData.resourceManager,
            resourceManagerEmail: this.resetUserData.resourceManagerEmail,
            empStatus: parseInt(this.resetUserData.empStatus),
            batchNo: this.resetUserData.batchNo,
            journeyCompletionDate: this.resetUserData.journeyCompletionDate
              ? moment(this.resetUserData.journeyCompletionDate).format(
                  'YYYY-MM-DD'
                )
              : null,
            isApproved: 3,
            createdByEmail: JSON.parse(localStorage.getItem('user')).userData
              .emailAddress,
          };

          this.commonService
            .saveUserProfileHistory(userProfileHistory)
            .pipe(first())
            .subscribe(
              (result) => {},
              (error) => {}
            );
          userProfileHistory.isApproved = 2;
          this.commonService
            .saveUserProfileHistory(userProfileHistory)
            .pipe(first())
            .subscribe(
              (result) => {},
              (error) => {}
            );

          const index = this.fetchData.findIndex(
            (item) => item.userId == this.resetUserId
          );
          if (index > -1) {
            this.fetchData.splice(index, 1);
          }
          localStorage.setItem('errorMsg', 'Data Successfully Updated');
          this.commonService.showerror();
        }
      },
      (error) => {
        console.log('Error in reset user data');
      }
    );
  }
  /**
   * Set userId for renomination.
   */
  onResetUserforReNomination(userId, resetUserData) {
    if (userId) {
      this.resetUserId = userId;
      this.resetUserData = resetUserData;
    }
  }
  /**
   * On click show user history.
   */
  onUserHistory(userData) {
    const userEmail = userData.email.toLowerCase();
    const data = { email: userEmail };
    this.nominatedUseristory = [];
    this.commonService.getNominatedUserHistory(data).subscribe(
      (data) => {
        if (data) {
          this.nominatedUseristory = data;
        }
      },
      (error) => {
        console.log('Error in reset user data');
      }
    );
  }

  getEmpStatus(status) {
    let empStatus = 'Active';
    if (status == 0) {
      empStatus = 'Deactive';
    } else if (status == 2) {
      empStatus = 'Resigned';
    }
    return empStatus;
  }

  onItemSelect(item: any) {
    this.dtRendered = false;
    // make sure your template notices it
    this.cdr.detectChanges();
    // initialize them again
    this.dtRendered = true;
    this.cdr.detectChanges();
  }

  /**
   * On deselect the selected tower.
   * @param item
   */
  onUnselectColumn(item) {
    this.dtRendered = false;
    // make sure your template notices it
    this.cdr.detectChanges();
    // initialize them again
    this.dtRendered = true;
    this.cdr.detectChanges();
  }

  trackColumn(index, column) {
    return column ? column.slug : undefined;
  }

  onSelectAll(items: any) {
    this.dtRendered = false;
    // make sure your template notices it
    this.cdr.detectChanges();
    // initialize them again
    this.dtRendered = true;
    this.cdr.detectChanges();
  }

  onUserImportSubmit(data) {
    const formData = new FormData();
    formData.append('file', this.importUserForm.get('userFile').value);
    formData.append('towerId', this.towerId);
    this.commonService.importUserData(formData).subscribe(
      (data) => {
        console.log('data', data);
        this.loading = false;
        localStorage.setItem('errorMsg', data.message);

        this.commonService.showerror();
      },
      (error) => {
        localStorage.setItem('errorMsg', error);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  onFileSelect(event) {
    if (event.target.files.length) {
      let file = event.target.files[0];
      this.importUserForm.get('userFile').setValue(file);
    }
  }

  private getAllIBUInfo() {
    this.loading = true;
    this.commonService
      .getAllIBUInfo()
      .pipe(first())
      .subscribe(
        (data) => {
          this.ibuList = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  public setFieldsData(fetchuserData) {
    
    this.fetchCurrentPositions(
      fetchuserData.towerId,
      fetchuserData.positionId
    );

    this.commonService
      .allInfoPosition(fetchuserData.nextPosition)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length) {
            const response = data[0];
            this.isNextTowerSame = response.towerId == fetchuserData['towerId'];
            this.onChangeIBU(null, response);            
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getTowersListByIbuId(ibuId, towerId, dataValue) {
    this.commonService.getTowersListByIbuId(ibuId, null).subscribe(
      (data) => {
        this.towerList = data;
        this.alltowerList = data;
        if (dataValue) {
          const formTower: any = document.querySelector('#form-tower');

          if (formTower) {
            setTimeout(() => {
              formTower.value = dataValue.towerId;
            }, 200);
          }

          this.fetchNextPositions(dataValue.towerId, dataValue.positionId);
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private getFunctionListByIbuId(ibuId, dataValue) {
    this.functionList = [];
    this.commonService.getFunctionListByIbuId(ibuId).subscribe(
      (data) => {
        this.functionList = data;
        if (dataValue) {
          const formFunction: any = document.querySelector('#form-function');
          console.log({ dataValue, formFunction });

          if (formFunction) {
            setTimeout(() => {
              formFunction.value = dataValue.functionId;
            }, 200);
          }
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private onChangeIBU(event, dataValue) {
    console.log({ dataValue });
    debugger;
    let ibu = dataValue ? dataValue.ibuId : event.target.value;

    if (dataValue) {
      const formIbu: any = document.querySelector('#form-ibu');

      if (formIbu) {
        formIbu.value = dataValue.ibuId;
      }
    }

    this.resetFunctionValue();
    this.resetTowerValue();
    if (ibu) {
      this.getFunctionListByIbuId(ibu, dataValue);
      this.getTowersListByIbuId(ibu, 0, dataValue);
    } else {
      this.resetFunctionList();
      this.resetTowerList();
    }
  }

  private onChangeFunction(event) {
    let functionId = event.target.value;
    this.resetTowerValue();
    if (functionId) {
      this.towerList = this.alltowerList.filter(
        (item) => item.functionId == functionId
      );
    } else {
      this.towerList = this.alltowerList;
    }
  }
  private onChangeTower(event: any) {
    this.fetchNextPositions(event.target.value);
  }

  private resetFunctionValue() {
    this.function = '';
  }

  private resetTowerValue() {
    this.tower = '';
  }

  private resetFunctionList() {
    this.functionList = [];
  }

  private resetTowerList() {
    this.towerList = [];
  }
}
